// new submodule
export default {
	/**
	 * Perform initial setters and add listeners for the given draft
	 * @param {Number} id DB id of the Draft
	 * @param {Number} articleId DB id of the Draft's Article
	 */
	initNewDraft(id, articleId) {
		pp.log("PLENARY initNewDraft -- id, articleId", id, articleId);

		const $draft = $(".Draft--public").attr("data-draft-id", id);

		pp.plenary.setArticleMenuTitle(articleId);
		// set timeago for present timestamps in draft
		$draft.find("time[data-time-ago]").timeago();

		// mark Comments/Discussions link active on click (if they exist)
		$(".PlenarySocial__submenu")
			.find("a")
			.on("click", function () {
				$(this).closest("ul").find("li").removeClass("active");
				$(this).closest("li").addClass("active");
				$(this).siblings("div.circle").remove(); // remove the 'unread' dot on the oldschool discussion menu entry
			});

		$(document).on("bootstrap:breakpoint-changed", () => {
			pp.global.initSelect2For($draft.find("select")); // Init those first so the select height is factored in in `normalizeContainerHeights`
			pp.viewHelpers.normalizeContainerHeights(
				".j-normalize-child-heights",
				".Module__content",
			);
			pp.viewHelpers.normalizeContainerHeights(
				".Plenary__social",
				".Module__content",
			);
		});

		/**
		 * Listen to any changes in the tree of $draft and normalize its childrens' heights.
		 * Don't use jQuery's `observe()`, it does not support the subtree option.
		 * ('childList' mutation type will also be triggered for the subtree, not just direct children)
		 */
		const observer = new MutationObserver((mutations) => {
			mutations.forEach(({ type, target }) => {
				if (
					type == "childList" &&
					$(target).hasClass("Module__content") &&
					pp.viewHelpers.isBreakpointOfSize(">sm")
				) {
					pp.viewHelpers.normalizeContainerHeights(
						".Draft--public",
						".Module__content",
					);
				}
			});
		});
		// @ts-expect-error
		observer.observe($draft[0], {
			subtree: true,
			childList: true,
		});
	},

	// set current Article links in overview active (if they exist)
	setArticleMenuTitle(articleId) {
		pp.log(
			"PLENARY setting Articles menu title -- articleId",
			articleId,
			$(".j-articles-menu"),
		);
		const $activeArticleLink = $(".j-articles-menu").find(
			`a[href='/articles/${articleId}']`,
		);
		$(".j-articles-menu")
			.find("a.button .j-article-title")
			.html($activeArticleLink.text());
		$(".j-articles-menu").find("li.active").removeClass("active"); // this should never be necessary because loading an Article means reloading the Articles menu as well
		$activeArticleLink.parent().addClass("active");
	},

	/**
	 * let diff_match_patch compute the difference between the displayed draft iteration and the previous one and display that difference
	 * in formatted HTML
	 */
	draftIterationDiff: {
		init(selector) {
			const $elem = $(selector);
			pp.plenary.draftIterationDiff.$newVersionElem = $elem; // Needed in `mceInitCallbackComp`
			pp.log(
				"PLENARY draftIterationDiff invoked -- elems:",
				$elem,
				$elem.attr("class"),
			);

			const prevDraftText = $elem.attr("data-previous-draft-text");

			if (prevDraftText === undefined || prevDraftText == "") {
				return;
			}

			// For comparision of rich text: Attach *two* new textareas, init their resp. TinyMCE editor, then call `showDiffBetweenEditors` which
			// handles the actualy visual comparision between the two
			if ($elem.attr("data-mce-interface") !== undefined) {
				const $cloneForComparison = $elem
					.clone()
					.attr("id", "buffer_string_for_comparison")
					.removeClass("j-initialized-mce");
				var $prevVersionClone = $elem
					.clone()
					.attr("id", "buffer_string_prev")
					.removeClass("j-initialized-mce")
					.val(prevDraftText);
				$elem.before($prevVersionClone);
				$prevVersionClone.addClass("tox-tinymce--no-negative-margin");
				$elem.before($cloneForComparison);

				pp.tinyMCE.init(
					"#buffer_string_prev",
					// @ts-expect-error
					pp.plenary.draftIterationDiff.mceInitCallbackPrev,
				);
			}

			// Old-School comparion of plain text
			else {
				// @ts-expect-error
				const dmp = new diff_match_patch();
				const diff = dmp.diff_main(prevDraftText, $elem.text().trim());
				dmp.diff_cleanupSemantic(diff);
				$elem.html(dmp.diff_prettyHtml(diff));
			}

			const $draftContainer = $elem.closest("[data-draft-id]"); // This will have been set by `initNewDraft` above
			$draftContainer
				.find(".Draft__diff-highlighting-key")
				.removeClass("hidden");

			const $diffToggleContainer = $draftContainer.find(
				"div.toggle_diff_highlighting",
			);
			$diffToggleContainer.removeClass("hidden");
			$diffToggleContainer
				.find("input[type='checkbox']")
				.on("change", (event) => {
					// @ts-expect-error
					$draftContainer[event.target.checked ? "removeClass" : "addClass"](
						"Draft--no-diff-highlighting",
					);
				});
			// Re-hide the diff toggle again when the Draft is being destroyed
			// (This should not be necessary because the `article_iterations_menu` which contains the diff toggle is also being re-rendered when loading another Draft)
			$elem.one("destroyed destroyed_proxy", () => {
				$diffToggleContainer.addClass("hidden");
			});
		},

		mceInitCallbackPrev(prevVersionEditor) {
			pp.log(
				"Initialized prev version editor",
				prevVersionEditor,
				prevVersionEditor.container,
			);

			pp.plenary.draftIterationDiff.prevVersionEditor = prevVersionEditor; // Store for the ballback below
			// NB this is a callback within a callback: Init TinyMCE for the previous version first, only then also
			// init TinyMCE for the comparison editor, and once that's initialized start the visual comparsion
			pp.tinyMCE.init(
				"#buffer_string_for_comparison",
				// @ts-expect-error
				pp.plenary.draftIterationDiff.mceInitCallbackComp,
			);
		},

		mceInitCallbackComp(comparisonEditor) {
			pp.log(
				"Initialized comparison editor",
				comparisonEditor,
				comparisonEditor.container,
			);

			const prevVersionEditor = pp.plenary.draftIterationDiff.prevVersionEditor;
			pp.tinyMCE.normalizeAndSaveContent(prevVersionEditor);
			pp.tinyMCE.normalizeAndSaveContent(comparisonEditor);
			const diffArr = comparisonEditor.diffMP.diff_main(
				prevVersionEditor.normalizedContent,
				comparisonEditor.normalizedContent,
			);
			comparisonEditor.diffMP.diff_cleanupSemantic(diffArr);
			pp.tinyMCE.showDiffBetweenEditors(
				diffArr,
				comparisonEditor,
				prevVersionEditor,
			);
			$(prevVersionEditor.container).addClass("hidden");

			// This`editor will only have been initiliazed in _draft_content *after* `draftIterationDiff` has been called
			const newVersionEditor =
				tinyMCE.editors[
					pp.plenary.draftIterationDiff.$newVersionElem.attr("id")
				];
			// @ts-expect-error
			$(newVersionEditor.container).addClass("Draft--new-version-mce-editor");
			$(comparisonEditor.container).addClass("Draft--comparison-mce-editor");
			comparisonEditor.getBody().firstChild.scrollIntoView();
		},
	},

	draftGapOptions: {
		targets: {},

		init(targetSelector) {
			pp.log(
				"PLENRAY draftGapOptions init -- selector, elem:",
				targetSelector,
				$(targetSelector),
			);
			const $targetContainer = $(targetSelector);
			const variablesHash = {
				$targetContainer: $targetContainer,
				$resultsContainer: $(
					"div.article-gap-options-properties-calculation[data-for-target='" +
						targetSelector +
						"']",
				),
				calculatedKeys: {},
			};
			variablesHash.$resultsContainer
				.find(".j-key-facts-block")
				.each(function () {
					const data = $(this).data();
					if (variablesHash.calculatedKeys[data.calculationKey] === undefined)
						variablesHash.calculatedKeys[data.calculationKey] = {};

					variablesHash.calculatedKeys[data.calculationKey].value = 0;
					if (data.negativeOf !== undefined) {
						if (variablesHash.calculatedKeys[data.negativeOf] === undefined)
							variablesHash.calculatedKeys[data.negativeOf] = {};

						variablesHash.calculatedKeys[data.negativeOf].subtrahend =
							data.calculationKey;
					}
				});
			this.targets[targetSelector] = variablesHash;
			$targetContainer.find("select").on("change", () => {
				pp.plenary.draftGapOptions.calculateAndShow(targetSelector);
			});
			$targetContainer.find("select").first().trigger("change"); // calculateAndShow once now
		},

		calculateAndShow(targetSelector) {
			//pp.log("PLENARY draftGapOptions calculateAndShow -- targetSelector:", targetSelector);
			const thisModule = pp.plenary.draftGapOptions.targets[targetSelector];
			const $targetContainer = thisModule.$targetContainer;
			const $resultsContainer = thisModule.$resultsContainer;

			for (const key in thisModule.calculatedKeys) {
				thisModule.calculatedKeys[key].value = 0;

				$targetContainer
					.find("select")
					.children(":selected[data-" + key + "]")
					.each(function () {
						//pp.log("PLENARY draftGapOptions calculateAndShow -- calculation key, and value stored in select option: \n", key, $(this).data(key))
						thisModule.calculatedKeys[key].value += parseFloat(
							// @ts-expect-error
							$(this).data(key),
						);
					});
				const $resultSpan = $resultsContainer
					.find(".j-key-facts-block[data-calculation-key='" + key + "']")
					.find("span.result");
				$resultSpan.html(
					thisModule.calculatedKeys[key].value.toLocaleString(I18n.locale),
				);
				$resultSpan.addClass("result--highlightThemeLight");
				setTimeout(() => {
					$resultSpan.removeClass("result--highlightThemeLight");
				}, 2000); // NB the `1500 corresponds to the duration of `2s` in LESS

				const subtrahend = thisModule.calculatedKeys[key].subtrahend;
				if (subtrahend === undefined) {
					continue;
				}

				const result =
					thisModule.calculatedKeys[key].value -
					thisModule.calculatedKeys[subtrahend].value;
				const $balanceContainer = $resultsContainer.find(
					".j-balance-block[data-calculation-key='" +
						key +
						"-" +
						subtrahend +
						"']",
				);

				// pp.log("res", result, $balanceContainer);
				pp.vue.bus.$emit("percent-bar-value-CHANGE", {
					value: result,
					bar_id: targetSelector + "-" + key + "-" + subtrahend,
				});
				if ($balanceContainer.length)
					$balanceContainer
						.find("span.number")
						.text(result.toLocaleString(I18n.locale));
			}
		},
	},
};
